import type { FC } from "react";
import type React from "react";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

const TopRightComponentContainer = styled(FlexRow)`
    justify-content: flex-end;
    flex: 1;
`;

const SubNavPageTitle = styled.div<{ shouldExpand: boolean }>`
    flex-grow: ${(props) => (props.shouldExpand ? 1 : 0)};
    text-overflow: ellipsis;
    overflow: hidden;
`;

export interface ISubNavProps {
    bottomRightComponent?: React.ReactNode;
    topLeftComponent?: React.ReactNode;
    topRightComponent?: React.ReactNode;
    bottomLeftComponent?: React.ReactNode;
    education?: React.ReactNode;
    numberOfComparedItems?: number;
    onTopComponentMouseEnter?: () => void;
    onTopComponentMouseLeave?: () => void;
}

export const SubNav: FC<ISubNavProps> = (props) => {
    const {
        topLeftComponent,
        topRightComponent,
        bottomRightComponent,
        education,
        bottomLeftComponent,
        onTopComponentMouseEnter,
        onTopComponentMouseLeave,
    } = props;

    const bottomBar = (
        <div className="subNav u-flex-row u-flex-center u-flex-space-between subNav-secondRow">
            {bottomLeftComponent ? (
                <SubNavPageTitle shouldExpand={Boolean(bottomRightComponent)}>{bottomLeftComponent}</SubNavPageTitle>
            ) : null}
            {bottomRightComponent ? <div className="subNav-filters">{bottomRightComponent}</div> : null}
        </div>
    );

    return (
        <>
            <div
                className="subNav u-flex-row u-flex-center"
                onMouseEnter={onTopComponentMouseEnter}
                onMouseLeave={onTopComponentMouseLeave}
            >
                {topLeftComponent ? (
                    <div
                        className={`subNav-header${topRightComponent ? "" : " subNav-header--fullWidth"}`}
                        data-automation="sub-nav-header"
                    >
                        {topLeftComponent}
                    </div>
                ) : null}
                {topRightComponent ? (
                    <TopRightComponentContainer data-automation="sub-nav-header-right">
                        {topRightComponent}
                    </TopRightComponentContainer>
                ) : null}
            </div>
            {bottomLeftComponent || bottomRightComponent ? bottomBar : null}
            {education ? (
                <div>
                    <div className="subNav-education">{education}</div>
                </div>
            ) : null}
        </>
    );
};
